import { render, staticRenderFns } from "./recipes.vue?vue&type=template&id=3e694906&scoped=true&"
import script from "./recipes.vue?vue&type=script&lang=js&"
export * from "./recipes.vue?vue&type=script&lang=js&"
import style0 from "./recipes.vue?vue&type=style&index=0&id=3e694906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e694906",
  null
  
)

export default component.exports